import { MENU_KEY_ROUTES } from "src/constants/modules";
import OrderDetails from "src/Modules/UserHistory/pages/OrderDetails/OrderDetails";
import {OrdersList} from "src/Modules/UserHistory/pages"

export const userRoutes = {
  path: MENU_KEY_ROUTES["History"],
  children: [
    {
      index: true,
      element: <OrdersList />,
    },
    {
      path:":module/:id",
      element:<OrderDetails/>,
    }
  ],
};
